import React from "react";
import { getColor } from "../../utils/color";
import { getAddSizeUnit } from "../../utils/size";
import { classnames } from "../../utils/text";

const Line = ({
  width,
  height,
  color = 'colorGray1',
  isVertical = false,
  style = {},
  className
}) => {
  const lineStyle = {
    display: isVertical ? 'inline-block' : 'block',
    verticalAlign: "middle",
    width: getAddSizeUnit(width || isVertical ? 1 : '100%'),
    height: getAddSizeUnit(height || 1),
    background: getColor(color) || color,
    ...isVertical ? {} : { clear: 'both' },
    ...style
  }
  return (
    <div
      style={{
        clear: 'both',
        ...isVertical ? { display: 'inline-block' } : {},
      }}
      className={classnames('custom-line', className, { 'vertical-line': isVertical })}
    >
      <div
        className="line"
        style={lineStyle}
      ></div>
    </div>
  );
};

export default Line;
